module.exports = __webpack_public_path__ + "img/992.5683f412.png";